const request = {
    invalid_input: 'Неверный ввод. {{details}}',
    general: 'Произошла ошибка запроса.',
    range_not_satisfiable: 'Диапазон не удовлетворен.',
};
export default Object.freeze(request);
